// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const environmentCommonFields = {
  code: "Code",
  name: "Name",
  displayName: "Display Name",
  category: "Category",
  architecture: "Architecture",
  status: "Status",
  visibility: "Visibility",
  shareMode: "Share Mode",
  usageType: "Usage",
  source: "Source",
  actions: "Actions",
  description: "Description",
  tags: "Tags",
  createdAt: "Created At",
  assetId: "Asset ID",
  declaredQemuGuestAgent: "qemu-guest-agent embedded in image",
  declaredAirangeVmAgent: "Manually declared airange-vm-agent preinstalled",
  declarationScope: "Declaration scope",
  filename: "Filename",
  objectSpace: "Object Space",
  contentType: "Content Type",
  fileSize: "File Size",
  declaredPorts: "Declared Ports",
  defaultAccessPorts: "Default Access Ports",
  transportProtocol: "Transport Protocol",
  guestPort: "Guest Port",
  serviceProtocol: "Service Protocol",
  portLabel: "Port Label",
} as const;
